"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bufferUntil = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
// Buffer values until the closing observable emits, then emit buffered values and switch to original stream
function bufferUntil(closing) {
    return stream => stream.pipe((0, operators_1.bufferToggle)((0, rxjs_1.of)(false), () => closing), (0, operators_1.switchMap)(initial => (0, rxjs_1.concat)((0, rxjs_1.from)(initial), stream)));
}
exports.bufferUntil = bufferUntil;
//# sourceMappingURL=buffer-until.js.map